import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M0 7a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v9a2 2 0 0 1-2 2H8v-2h3.5a.5.5 0 0 0 .5-.5V7a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h1v2H3a3 3 0 0 1-3-3z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 7h6.225a3 3 0 0 1 2.021.783l2.775 2.53A3 3 0 0 1 24 12.53V15a3 3 0 0 1-3 3h-1v-2h1a1 1 0 0 0 1-1v-2.47a1 1 0 0 0-.326-.739l-2.775-2.53A1 1 0 0 0 18.225 9H15a1 1 0 0 0-1 1v5.5a.5.5 0 0 0 .5.5H16v2h-4zM6 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 2a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M18 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 2a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }